import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { CardContent, CardHeader, Grid } from '@material-ui/core';
import Card from 'components/base/Card';
import { isEmpty } from 'lodash';
import { Alert } from '@material-ui/lab';
import Post from '../../CompetitiveReport/TopContent/Post';
import styles from './styles';


const VerticalPosts = ({ classes, posts }) => (
  <Card>
    <CardHeader title="Sample of Top Content" />
    <CardContent>
      {isEmpty(posts) && (
        <Alert severity="warning">
              We don&apos;t have sufficient data for this vertical. Please try again later.
        </Alert>
      )}
      <Grid container spacing={2}>
        {posts.map(p => (
          <Grid className={classes.gridItem} item xs={12} sm={6} md={3}>
            <Post data={p} />
          </Grid>
        ))}
      </Grid>
    </CardContent>
  </Card>
);

VerticalPosts.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default withStyles(styles)(VerticalPosts);
